import React, { useEffect, useState, useCallback } from "react";
import { useSelector, useDispatch } from "react-redux";
import { setLoading, setModule } from "../../store/actions/commonAction";
import CommonDataService from "../../services/common";
import {
	AllowedUsergroup,
	GetIndexByValue,
	parseNumber,
} from "../../helpers/common";

import Grid from "@mui/material/Grid";
import Paper from "@mui/material/Paper";
import Box from "@mui/material/Box";
import Typography from "@mui/material/Typography";
import Autocomplete from "@mui/material/Autocomplete";
import TextField from "@mui/material/TextField";
import Button from "@mui/material/Button";
import Divider from "@mui/material/Divider";
import SaveIcon from "@mui/icons-material/Save";
import Alert from "@mui/material/Alert";

import MessageDialog from "../MessageDialog";
import http from "../../http";

export default function SocialMediaLink({ placeholder }) {
	const dispatch = useDispatch();

	const [facebook, setFacebook] = useState("");
	const [twitter, setTwitter] = useState("");
	const [threads, setThreads] = useState("");
	const [tiktok, setTiktok] = useState("");
	const [linkedin, setLinkedin] = useState("");
	const [youtube, setYoutube] = useState("");
	const [instagram, setInstagram] = useState("");
	const [metaDescription, setMetaDescription] = useState("");
	const [metaTitle, setMetaTitle] = useState("");
	const [whatsapp, setWhatsapp] = useState("");

	const company = useSelector((state) => state.commonReducer.user.company);
	const userGroup = useSelector((state) => state.commonReducer.user.usergroup);

	const loading = useSelector((state) => state.commonReducer.loading);

	const [message, setMessage] = useState("");
	const [error, setError] = useState(false);
	const [success, setSuccess] = useState(false);

	const [offices, setOffices] = useState([]);
	const [idOffice, setIdOffice] = useState(company);
	const [idOfficeAC, setIdOfficeAC] = useState(null);

	const LoadSelect = useCallback(() => {
		dispatch(setLoading(true));

		dispatch(setModule("Social Media Link"));

		CommonDataService.GetSocialMediaLink(idOffice).then((res) => {
			dispatch(setLoading(false));

			setFacebook(res.data.facebook);
			setTwitter(res.data.twitter);
			setThreads(res.data.threads);
			setTiktok(res.data.tiktok);
			setLinkedin(res.data.linkedin);
			setYoutube(res.data.youtube);
			setInstagram(res.data.instagram);
			setMetaDescription(res.data.meta_description);
			setMetaTitle(res.data.meta_title);
			setWhatsapp(res.data.whatsapp);
		});

		if (AllowedUsergroup(userGroup, "superuser-website")) {
			CommonDataService.getOffices().then((res) => {
				setOffices(res.data);
			});
		}
	}, [dispatch, idOffice, userGroup]);

	useEffect(() => {
		setIdOfficeAC(GetIndexByValue(offices, idOffice));
	}, [offices, idOffice]);

	useEffect(() => {
		LoadSelect();
	}, [LoadSelect]);

	const handleSubmit = (event) => {
		event.preventDefault();

		const data = {
			company: parseNumber(idOffice),
			facebook: facebook,
			twitter: twitter,
			threads: threads,
			tiktok: tiktok,
			linkedin: linkedin,
			youtube: youtube,
			instagram: instagram,
			meta_description: metaDescription,
			meta_title: metaTitle,
			whatsapp: whatsapp,
		};

		dispatch(setLoading(true));
		setSuccess(false);

		http
			.post("/socialmedialink", data)
			.then((res) => {
				dispatch(setLoading(false));
				setSuccess(true);
			})
			.catch(function (error) {
				setMessage(error.response.data.message);
				setError(true);
				dispatch(setLoading(false));
			});
	};

	return (
		<Grid container spacing={3}>
			<Grid item xs={12}>
				<MessageDialog show={error} message={message} dialogClose={setError} />

				<Paper
					sx={{
						p: 2,
						display: "flex",
						flexDirection: "column",
					}}
				>
					{success && <Alert severity="success">Success</Alert>}
					<Box component="form" onSubmit={(e) => handleSubmit(e)}>
						<Typography variant="h5">Set Social Media Link</Typography>

						<Grid container spacing={3}>
							{AllowedUsergroup(userGroup, "superuser-website") && (
								<Grid item xs={12} sm={12}>
									<Autocomplete
										id="id_office"
										name="id_office"
										options={offices}
										getOptionLabel={(option) => option.name}
										isOptionEqualToValue={(option, value) =>
											option.value === value.value
										}
										fullWidth={true}
										onChange={(e, val) => {
											if (val !== null) {
												setIdOffice(val.id);
											} else {
												setIdOffice("");
											}
										}}
										value={idOfficeAC}
										sx={{ minWidth: 100 }}
										renderInput={(params) => (
											<TextField
												variant="standard"
												{...params}
												label="Office"
											/>
										)}
									/>
								</Grid>
							)}

							<Grid item xs={12} sm={6}>
								<TextField
									label="Facebook"
									value={facebook}
									fullWidth
									variant="standard"
									onChange={(e) => setFacebook(e.target.value)}
								/>
							</Grid>
							<Grid item xs={12} sm={6}>
								<TextField
									label="Twitter"
									value={twitter}
									fullWidth
									variant="standard"
									onChange={(e) => setTwitter(e.target.value)}
								/>
							</Grid>
							<Grid item xs={12} sm={6}>
								<TextField
									label="Threads"
									value={threads}
									fullWidth
									variant="standard"
									onChange={(e) => setThreads(e.target.value)}
								/>
							</Grid>
							<Grid item xs={12} sm={6}>
								<TextField
									label="Tiktok"
									value={tiktok}
									fullWidth
									variant="standard"
									onChange={(e) => setTiktok(e.target.value)}
								/>
							</Grid>
							<Grid item xs={12} sm={6}>
								<TextField
									label="Linked in"
									value={linkedin}
									fullWidth
									variant="standard"
									onChange={(e) => setLinkedin(e.target.value)}
								/>
							</Grid>
							<Grid item xs={12} sm={6}>
								<TextField
									label="Youtube"
									value={youtube}
									fullWidth
									variant="standard"
									onChange={(e) => setYoutube(e.target.value)}
								/>
							</Grid>
							<Grid item xs={12} sm={6}>
								<TextField
									label="Instagram"
									value={instagram}
									fullWidth
									variant="standard"
									onChange={(e) => setInstagram(e.target.value)}
								/>
							</Grid>
							<Grid item xs={12} sm={6}>
								<TextField
									label="Whatsapp Number"
									value={whatsapp}
									fullWidth
									variant="standard"
									onChange={(e) => setWhatsapp(e.target.value)}
								/>
							</Grid>

							<Grid item xs={12} sm={12}>
								<TextField
									label="Meta Description"
									fullWidth
									multiline
									rows={4}
									value={metaDescription}
									onChange={(e) => setMetaDescription(e.target.value)}
								/>
							</Grid>

							<Grid item xs={12} sm={12}>
								<TextField
									label="Meta Title"
									value={metaTitle}
									fullWidth
									variant="standard"
									onChange={(e) => setMetaTitle(e.target.value)}
								/>
							</Grid>
							

							<Grid item xs={12} sm={12}>
								<Divider />
							</Grid>

							<Grid item xs={12} sm={12}>
								<Button
									type="submit"
									variant="contained"
									disabled={loading}
									startIcon={<SaveIcon />}
								>
									{loading && (
										<span>
											<span className="spinner-border spinner-border-sm"></span>
											&nbsp;
										</span>
									)}
									<span> {loading ? "Please Wait" : "Save"}</span>
								</Button>
							</Grid>
						</Grid>
					</Box>
				</Paper>
			</Grid>
		</Grid>
	);
}
